import { Component, EventEmitter, Input, OnInit, Output, SimpleChanges, OnChanges } from '@angular/core';
import { FormControl } from '@angular/forms';

@Component({
  selector: 'app-date-picker',
  templateUrl: './date-picker.component.html',
  styleUrls: ['./date-picker.component.scss'],
  standalone: false,
})
export class DatePickerComponent implements OnInit, OnChanges {
  @Input() minDate!: string;
  @Input() maxDate!: string;
  @Input() date!: string;
  @Output() dateChange = new EventEmitter<string>();

  dateControl: FormControl = new FormControl(this.date);

  constructor() {}

  ngOnInit(): void {
    this.dateControl.setValue(this.date);

    this.dateControl.valueChanges.subscribe((value) => {
      if (!value) return;
      this.dateChange.emit(value);
    });
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['date'] && changes['date'].currentValue !== this.dateControl.value) {
      this.dateControl.setValue(changes['date'].currentValue, { emitEvent: false });
    }
  }

  resetDate(): void {
    this.dateControl.setValue(null);
  }
}
